import React from 'react';
import PropTypes from 'prop-types';
import { GeneralSelect } from 'sharedComponents/GeneralSelect';
import Option from './Option';

const AssetGroupSelector = (props) => {

	const {
		...otherProps
	} = props;
	return <GeneralSelect
		{...otherProps}
		getOptionLabel={option => option.name}
		getOptionValue={option => option.id}
		components={{ Option }}
		className='general-filter-selector-container assetgroup-selector-container asset-group-selector'
		blurInputOnSelect={false}
		isMulti
		isDisabled={props.isLoading || !props.assetGroupChecked}
		closeMenuOnSelect={false}
		hideSelectedOptions={false}
	/>;
};

AssetGroupSelector.propTypes = {
	assetGroupChecked: PropTypes.bool,
	isLoading: PropTypes.bool
};

export default AssetGroupSelector;
